import { render } from "./Speed125.vue?vue&type=template&id=3bac2d52"
import script from "./Speed125.vue?vue&type=script&lang=js"
export * from "./Speed125.vue?vue&type=script&lang=js"
script.render = render

export default script